(function notificationFindControllerDefinition() {
    'use strict';

    angular.module('Notification')
        .controller('NotificationFindController', [
            '$scope', '$state', '$translate', 'errorsExtend', 'notificationService', 'processService',
    function notificationFindController($scope, $state, $translate, errors, notificationService, processService) {

        $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
            .then(function (translated) {
                $scope.paginatorTranslations = {
                    nextText: translated.PaginationNext,
                    previousText: translated.PaginationPrev,
                    lastText: translated.PaginationLastFem,
                    firstText: translated.PaginationFirstFem
                };
            });

        $scope.clear = function () {
  
            $scope.filters = {
                selectedNotificationType: '',
                accordionIsOpen: true,
                notificationTypes: [],
                notificationDateFrom: undefined,
                notificationDateTo: undefined,
                itemPerPage: 15,
                currentPage: 1,
                from: 0,
                totalItems: 0
            }

            $scope.notificationsTypes.forEach(function (item) {
                $scope.filters.notificationTypes.push(item.key);
            });
        };

        $scope.search = function () {
            $scope.filters.notificationState = 1; // enviadas solamente
            if ($scope.filters.selectedNotificationType) {
                $scope.filters.notificationTypes = [$scope.filters.selectedNotificationType];
            }
            
            return notificationService.get($scope.filters).then(function (result) {
                if (result.value.length > 0) {
                    $scope.filters.accordionIsOpen = false;
                }

                $scope.showResult = true;
                $scope.notifications = result.value.values;

                $scope.filters.totalItems = result.value.count;
                $scope.filters.from = 1 + ($scope.filters.itemPerPage * ($scope.filters.currentPage - 1));
            }, function (error) {
                errors.showError(error);
            });
        };

        $scope.goNotifaction = function (notification) {
            $state.go(notification.link, { id: notification.processId });
        };

        $scope.load = function () {
            $scope.notifications = [];
            $scope.showResult = false;
            notificationService.getTypes().then(function (result) {
                $scope.notificationsTypes = result.value;
                $scope.clear();
                $scope.search();
            }, function (error) {
                errors.showError(error);
            });

        };

        $scope.load();

    }]);
})();